

















































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  InvitationToken,
  ParticipantInvitation,
  ParticipantInvitationListDTO,
  ProjectSite,
} from '../../../store/modules/projects/types/projects.types';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/utils/date.util';

@Component({
  components: {},
})
export default class InvitationList extends Vue {
  @Prop() public participantInvitations!: ParticipantInvitation[];
  @Prop() public projectSites!: ProjectSite[];

  get invitations() {
    if (this.participantInvitations) {
      const data: ParticipantInvitationListDTO[] = this.participantInvitations.map(
        (invitation: ParticipantInvitation) => {
          return {
            userEmail: invitation.invitationToken.email,
            participantRole: invitation.role,
            participantSites: this.siteNames(invitation.siteIds),
            token: invitation.invitationToken,
          };
        },
      );

      return data.slice(0, 5);
    }
    return [];
  }

  public siteNames(siteIds: number[]): string[] {
    return this.projectSites
      .filter((ps) => siteIds.includes(ps.site.id))
      .map((ps) => ps.site.name);
  }

  get dayjs() {
    return dayjs;
  }

  public invitationDate(item: InvitationToken): string | null {
    return dayjs(item.updatedAt || item.createdAt).format(DATE_FORMAT) || null;
  }

  public invitationStatus(invitation: InvitationToken) {
    if (invitation.acceptedAt) {
      return 'Accepted';
    }

    if (new Date(invitation.expiredAt) <= new Date()) {
      return 'Expired';
    } else {
      return 'Pending';
    }
  }

  public handleNavigate() {
    this.$emit('changeActiveTab', '#participants');
  }
}
